import { useEffect } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

import { useDisclosure } from '../../../utils/useDisclosure';
import ChatModal from '../../../components/parentDashboard/ChatModal';
import useParent from '../../../hooks/useParent';

const DashboardMain = () => {
  const chatModal = useDisclosure();
  const { currentChild } = useParent();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentChild) {
      navigate('/parent/settings', { state: { label: 'Account Information' } });
    }
  }, [currentChild, navigate]);

  return (
    <section className="px-10 mt-[10vh] py-1">
      <div className="md:flex md:gap-x-10">
        <div className="flex-[0.4]">
          <h1 className=" text-[#3c3c3c] md:text-4xl text-3xl font-normal font-['Inter'] pt-10 mb-10">
            Your Child’s Average
            <br />
            Grading Today
          </h1>
          <p className=" text-[#3c3c3c] text-9xl font-light font-['Inter'] mb-5">
            A,87%{' '}
          </p>
          <p className="">
            <span class="text-[#3c3c3c] text-xl font-normal font-['Inter']">
              Latest update added{' '}
            </span>
            <span class="text-[#8147e7] text-xl font-normal font-['Inter']">
              Jan 27
            </span>
          </p>
        </div>
        <div className="flex-[0.6]">
          <div className="flex justify-between items-center w-full">
            <h3 className="text-[#3c3c3c] text-xl font-semibold font-['Inter']">
              Recent Events
            </h3>
            <Link
              to={'/parent/events'}
              className="bg-[#8147E7] text-white text-xs py-2 px-3 rounded-full"
            >
              Show All
            </Link>
          </div>

          <div className="flex bg-white px-8 py-5 mt-4 rounded-lg">
            <div className="flex-[0.1]">
              <img src="/blackman.png" alt="blackman" className="w-10 h-10" />
            </div>
            <div className="flex-[0.9]">
              <div>
                <p className="text-black text-lg font-normal font-['Inter'] leading-normal">
                  Tolulope Ayodeji
                </p>
                <p className="text-[#707070] text-base font-normal font-['Inter'] leading-tight">
                  Teacher Coordinator
                </p>
              </div>
              <div className="bg-[#F0F0F0] mt-5 py-2.5 px-3.5">
                <p className=" text-black text-sm font-medium font-['Inter'] leading-[16.95px] mb-2">
                  Book Fair
                </p>
                <p className="text-[#707070] text-sm font-normal font-['Inter'] leading-[16.95px]">
                  Join us on March 51 for our Bok Fair! Explore captivating
                  reads for the entire family, seize the opportunity ot
                  enrich.Join us on March 51 for our Bok Fair! Explore
                  captivating reads for the entire family, seize the opportunity
                  ot enrich.
                </p>
              </div>

              <p className="mt-2.5 text-right text-[#707070] text-sm font-normal font-['Inter'] leading-[16.95px]">
                January 27, 1:43 PM
              </p>

              <div className="mt-5 flex justify-between">
                <div className="flex gap-1 items-center">
                  <div className="flex">
                    <span>
                      <img src="/personone.svg" alt="personone" />
                    </span>
                    <span className="translate-x-[-10px]">
                      <img src="/persontwo.svg" alt="persontwo" />
                    </span>
                    <span className="translate-x-[-20px]">
                      <img src="/personthree.svg" alt="personthree" />
                    </span>
                  </div>
                  <p className="w-[145px] h-[19px] justify-start text-[#707070] text-base font-normal font-['Inter'] leading-tight">
                    29 Comments
                  </p>
                </div>
                <div className="items-center justify-center px-[18px] h-7 bg-[#8147e7] flex gap-1 text-white rounded-[14px]">
                  <span>
                    <FaPlus />
                  </span>
                  <span className=" text-right justify-center text-white text-[13px] font-normal font-['Inter'] leading-none">
                    Add to calendar
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col md:flex-row md:gap-x-10 md:gap-y-0 gap-y-10 mt-8 ">
        <div className="flex-[0.4]">
          <p className=" text-[#424242] text-lg font-semibold font-['Inter'] mb-5">
            Upcoming Events
          </p>
          <div className="grid grid-cols-3 gap-3">
            {Array.from({ length: 6 }, (_, index) => (
              <Link
                to={'/parent/student-profile'}
                key={index}
                className="max-w-[157px] h-[135px] bg-white rounded-[10px] flex flex-col justify-between py-5 px-[14px]"
              >
                <p className="w-[47px] h-9 justify-start text-black text-[32px] font-medium font-['Inter']">
                  22
                </p>
                <p className="w-[99px] justify-start text-neutral-500 text-base font-normal font-['Inter']">
                  Monday
                </p>
              </Link>
            ))}
          </div>
        </div>

        {/* Schedule and Contacts */}
        <div className="flex md:flex-row flex-col md:flex-[0.6] md:gap-x-4 gap-y-4">
          <div className="bg-white rounded-[10px] py-3 px-5 flex-1">
            <h3 className=" text-[#424242] text-lg font-semibold font-['Inter'] mb-4">
              Today’s Schedule
            </h3>
            <div className="flex flex-col ">
              {Array.from({ length: 7 }, (_, index) => (
                <div
                  className={`${
                    index === 6 ? '' : 'border-b border-[#B5B5B5]'
                  } flex justify-between p-2`}
                >
                  <span className=" text-[#424242] text-sm font-light font-['Inter']">
                    8:45 - 10:am
                  </span>
                  <span className="text-right text-[#424242] text-sm font-base font-['Inter']">
                    English Language
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-[10px] py-3 px-5 flex-1">
            <h3 className="text-[#424242] text-lg font-semibold font-['Inter'] mb-4">
              Contacts
            </h3>
            <div className="flex flex-col">
              {Array.from({ length: 5 }, () => (
                <div
                  onClick={chatModal.open}
                  className="border border-[#E8E8E8] flex rounded-[5px] items-center gap-2 px-3 mb-2"
                >
                  <img src="/blackman.png" alt="blackman" className="w-10" />

                  <div className="flex flex-col gap-1">
                    <p className=" text-black text-sm font-medium font-['Inter']">
                      Ayodeji Omojuwa
                    </p>
                    <p className=" text-[#515050] text-sm font-light tracking-wide font-['Inter']">
                      Mathematics
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {chatModal.isOpen && <ChatModal modal={chatModal} />}
    </section>
  );
};

export default DashboardMain;
